<div>
  @defer (when profileService.profile) {
    <app-user-form
      [edit]="false"
      [(value)]="profileService.profile"
      [create]="false"
      [delete]="false"
      [profile]="profileService.profile()"
      [access]="accessService.access()"
    ></app-user-form>
  }
</div>
